/* eslint-disable ember/classic-decorator-hooks */
import * as FeedForwardStepResponse from '../../../step-response/feed-forward';
import Circuit from './circuit';
import BigHugeCircuitGroup from './big-huge-circuit-group';
import BaseMain from '../../implementation-common/base-main';
import PieWedge from '../../implementation-common/base-pie-wedge';
import * as ReverseImplementation from './reverse-implementation';

export default class DeliyannicBandPassMain extends BaseMain {
  bigHugeCircuitGroupModel;
  algorithm;

  init() {
    this.bigHugeCircuitGroupModel = BigHugeCircuitGroup;
    this.reverseImplementation = ReverseImplementation;
  }

  getStepValues(idealStep, circuit, timeAxis) {
    var k = (circuit.r3.value + circuit.r4.value) / circuit.r3.value;
    var result = FeedForwardStepResponse.getActualStepResponse(idealStep, circuit, timeAxis, k);
    return result;
  }

  createCircuit(stageFp, gain, stageQ, optimization, initialCapacitorValue) {
    var result = Circuit.create({
      algorithm: this.algorithm,
      stageFp: stageFp,
      gain: gain,
      stageQ: stageQ,
      optimization: optimization,
      initialCapacitorValue: initialCapacitorValue,
    });
    return result;
  }

  createBigHugeCircuitGroup(commercialCircuit, toleranceInput) {
    return this.bigHugeCircuitGroupModel.create({ circuit: commercialCircuit, toleranceInput: toleranceInput });
  }

  getInterestingCircuits(commercialCircuit, toleranceInput) {
    var pieWedgeTable = [];
    var bigHugeCircuitGroup = this.bigHugeCircuitGroupModel.create({
      circuit: commercialCircuit,
      toleranceInput: toleranceInput,
    });
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: -180,
        range: 10,
        explanatoryText: 'low Q mid fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: -135,
        range: 15,
        explanatoryText: 'low Q low fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: -90,
        range: 10,
        explanatoryText: 'mid Q low fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: -45,
        range: 15,
        explanatoryText: 'high Q low fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: -20,
        range: 15,
        explanatoryText: 'high Q med-low fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: 0,
        range: 10,
        explanatoryText: 'high Q mid fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: 20,
        range: 15,
        explanatoryText: 'high Q med-high fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: 45,
        range: 15,
        explanatoryText: 'high Q high fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: 90,
        range: 15,
        explanatoryText: 'mid Q high fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: 135,
        range: 10,
        explanatoryText: 'low Q high fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );

    var result = pieWedgeTable.map((pieWedge) => {
      return pieWedge.interestingCircuit;
    });
    return result;
  }
}
